



























import { defineComponent, PropType } from '@vue/composition-api';
import { EditTextAction } from '@oare/types';

export default defineComponent({
  props: {
    canPerformAction: {
      type: Boolean,
      required: true,
    },
    action: {
      type: String as PropType<EditTextAction>,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabledMessage: {
      type: String,
      required: false,
    },
  },
});
